import * as bg16 from '../actions/bg16.actions';
import * as moment from 'moment';
export interface State {
  page_content: any;
}
export const initialState = {
    page_content: {}
};

export function reducer(state = initialState, action: bg16.Actions) {
  switch (action.type) {
    case bg16.GO_TO_PAGE_BG16: {
      const data = transformResponse(action.payload);
      return Object.assign({}, state, {
        ...state,
        page_content: {
          data: data.data,
          noOfRecords: data.noOfRecords,
          totalNoOfPages: data.totalNoOfPages
        }
      });
    }

    default:
      return state;
  }
}

function transformResponse(data) {
  const numOfRecords = data['noOfRecords'];
  const numOfPages = data['totalNoOfPages'];
  data = data['policyTransactionsList'];
  if (!data) {
    return {
      noOfRecords: 0,
      totalNoOfPages: 0,
      data: []
    };
  }
  return {
    noOfRecords: numOfRecords,
    totalNoOfPages: numOfPages,
    data: data.map(e => {
      return {
        BG16_16: e['transactionNo'],
        // Fixed workitem 433
        // BG16_17: moment(e['transactionDate']).format('YYYY-MM-DD'),
        BG16_17: moment(e['requestDate']).format('DD/MM/YYYY'),
        BG16_18: e['transactionTypeName'],
        BG16_19: e['policyNo'],
        BG16_20: e['productName'],
        BG16_21: e['transactionStatusName'],
        BG16_22: e['requestedByName']
      };
    })
  };
}
